import { Link } from "@tanstack/react-router";
import { trackSignUp } from "@/lib/tracking";
import { cn } from "@/lib/utils";

interface FinalCTAProps {
  className?: string;
}

const FinalCTA = ({ className }: FinalCTAProps) => {
  return (
    <section className={cn("pt-28 pb-0 px-6 md:px-10", className)}>
      <div className="max-w-6xl mx-auto">
        <div className="rounded-t-2xl rounded-b-none border-[12px] border-b-0 border-accent/40 bg-card/40 backdrop-blur px-8 md:px-16 pt-20 md:pt-28 pb-16 md:pb-20">
          <div className="max-w-3xl mx-auto text-center">
            <h2
              className="text-4xl md:text-6xl leading-[1.05] tracking-tight mb-6"
              style={{ fontFamily: "var(--font-display)" }}
            >
              Try Bigdelta
            </h2>
            <p className="text-base md:text-lg text-muted-foreground mb-8">
              No credit card required. You get the first 100,000 pageviews and
              1,000 session replays free every month.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
              <a
                href="https://eu.bigdelta.com/sign-up"
                onClick={trackSignUp}
                className="bg-foreground text-background px-6 py-3 rounded-full text-sm font-medium hover:bg-foreground/90 transition-colors"
              >
                Start free
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
